module.exports = __webpack_public_path__ + "static/media/zheng2-1@2x.98159280.png";